export interface RequestGuard {
  begin: () => number
  isCurrent: (requestId: number) => boolean
  dispose: () => void
}

export function createRequestGuard(): RequestGuard {
  let currentId = 0
  let disposed = false

  return {
    begin() {
      currentId += 1
      return currentId
    },
    isCurrent(requestId: number) {
      return !disposed && requestId === currentId
    },
    dispose() {
      disposed = true
    },
  }
}
